/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";

import Image from "next/image";
import Link from "next/link";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "10px",
    background: "#FFF",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
    "&:hover": {
      boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
    },
  },
  image: {
    borderRadius: "10px",
  },
  t1: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#009693",
    marginTop: 10,
    padding: 10,
    paddingBottom: 5,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  t2: {
    fontSize: "16px",
    color: "#292929",
    padding: 10,
    paddingTop: 0,
    textAlign: "justify",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));

const ProjectCard = ({ image, title, subtitle, slug, type }) => {
  const classes = useStyles();

  return (
    <Link
      href={
        type === "campaign"
          ? `/agape-campaigns/${slug}`
          : `/crowdfunding/${slug}`
      }
    >
      <a>
        <Grid container className={classes.container} alignItems="center">
          <Grid item xs={12}>
            {image && (
              <Image
                src={image}
                blurDataURL={image}
                placeholder="blur"
                alt={title}
                layout="responsive"
                width={380}
                height={230}
                className={classes.image}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3" className={classes.t1}>
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.t2}>
              {subtitle}
            </Typography>
          </Grid>
        </Grid>
      </a>
    </Link>
  );
};

export default ProjectCard;
